/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import React, { useState, useEffect } from 'react';
import { useBandwidth } from '../../../../../hooks/partnership/bandwidth/useBandwidth';
import PartnershipBandwidthScheduleTable from './PartnershipBandwidthScheduleTable';

const PartnershipBandwidthBody = () => {
  const [view, setView] = useState(false);

  return (
    <div className="col-12 p-0 after-summary">
      <div className="row mx-2">
        <div className="col-12 d-flex mt-2">
          <button
            className="btn btn-green mr-3"
            type="button"
            data-toggle="modal"
            // data-target="#add_item"
            onClick={() => setView(true)}
          >
            Add Partnership Bandwidth
          </button>
        </div>

        <div className="card x-panel p-0">
          <PartnershipBandwidthScheduleTable view={view} setView={setView} />
        </div>
      </div>
    </div>
  );
};

export default PartnershipBandwidthBody;
